import { useState } from "react";
import { Link2, Check, Mail } from "lucide-react";

const enc = encodeURIComponent;

export const ShareButtons = ({ article }) => {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}/api/share/${article.slug}`;
  const text = article.headline;
  const links = [
    ["x", "X", `https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(text)}`],
    ["facebook", "Facebook", `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`],
    ["whatsapp", "WhatsApp", `https://wa.me/?text=${enc(`${text} ${url}`)}`],
  ];

  const copy = async () => {
    await navigator.clipboard.writeText(url).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const cls = "inline-flex items-center gap-1.5 font-ui text-xs px-3 py-1.5 border border-[#CFCFCB] hover:border-[var(--ink)] hover:text-[var(--accent)] transition-colors";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="article-share-buttons">
      <span className="meta mr-2">Share</span>
      {links.map(([key, label, href]) => (
        <a key={key} href={href} target="_blank" rel="noopener noreferrer" className={cls} data-testid={`share-${key}-link`}>{label}</a>
      ))}
      <a href={`mailto:?subject=${enc(text)}&body=${enc(url)}`} className={cls} data-testid="share-email-link"><Mail size={13} /> Email</a>
      <button type="button" onClick={copy} className={cls} data-testid="share-copy-link-button">
        {copied ? <><Check size={13} /> Copied</> : <><Link2 size={13} /> Copy link</>}
      </button>
    </div>
  );
};
